import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { LoadingState } from "../stats_components/LoadingState";
import renderFightType from "../render_box_fights_utilities/RenderFightTypeFunction";

const MainContainer = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 50px;
`;


function TableListMatch(props) {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    function handleEditMatch(idMatch) {
        let url = '/match/edit/' + idMatch;
        navigate(url);
    }

    // Navigazione verso wrestler
    function navigateToWrestler(wrestler) {
        setIsLoading(true);
        const wrestlerId = wrestler.wrestler_id;
        const wrestlerName = wrestler.name;
        navigate(`/wrestlers/i_${wrestlerId}_d_${wrestlerName}`);
    }

    // Se sta caricando, mostra il loader
    if (isLoading) {
        return <LoadingState />;
    }


    return (
        <MainContainer className='MainContainerTableListMatch'>
            {props.listMatch.map((matchInfo, keyMatchInfo) => (
                matchInfo.wrestlers.length > 0 && (
                    <>
                        {renderFightType(matchInfo, keyMatchInfo, navigateToWrestler)}
                    </>
                )
            ))}
        </MainContainer>
    )
}

export default TableListMatch;

{/* //Bottoni  */}
                                {/* <div className={`box-action-match ${visibleMatches[keyMatchInfo] ? 'd-flex' : 'd-none'}`}>

                                    <div 
                                        className={`box-btn-edit-delete-admin d-flex w-100 justify-content-center align-items-center
                                            ${props.user && (props.user.is_admin || props.user.is_founder || props.user.is_super_admin) ? '' : 'd-none'}`}
                                    >
                                        <button 
                                            type="submit" 
                                            className={`btn btn-primary my-3 mx-1`}
                                            onClick={()=>handleEditMatch(matchInfo.id)}
                                        >
                                            Modifica
                                        </button>
                                        <button type="submit" 
                                                className={`btn btn-danger`}
                                                    >Elimina
                                        </button>
                                    </div>
                                    
                                </div> */}